
import {spApi} from './sp'

export const reactivateSubscriptionApi = spApi.injectEndpoints({
  endpoints: (builder) => ({
    
    reactivateSubscription: builder.mutation({
     
      query: ({payload}) => ({
        url: '/reactivatesubscription',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Subscription'],
    }),

  }),
  overrideExisting: false,
})

export const { useReactivateSubscriptionMutation } = reactivateSubscriptionApi